import React, { useEffect } from 'react';
import { ReactComponent as ChevronRightIcon } from '../../media/icons/chevron-right.svg';
import { getSurveyConfig } from '../../utils';
import { getUserId } from '../../core/auth';
import * as pollfish from 'cordova-plugin-pollfish/www/pollfish';

const Pollfish = ({ survey, classes, pollfishRef }) => {
  useEffect(() => {
    if (!pollfishRef.current) {
      const config = getSurveyConfig(survey, 'pollfish');
      let builder = new pollfish.Builder(
        process.env.REACT_APP_POLLFISH_ANDROID_KEY,
        process.env.REACT_APP_POLLFISH_IOS_KEY
      );
      for (const key of ['offerwallMode', 'rewardMode', 'releaseMode']) {
        const value = config[key];
        if (value === true || value === false) {
          builder = builder[key](value);
        }
      }
      builder = builder.requestUUID(getUserId());
      const params = builder.build();
      pollfishRef.current = params;
      pollfish.init(params);
    }
  }, [pollfishRef, survey]);
  const open = () => {
    pollfish.show();
  };

  return (
    <div className={classes.surveyItem} onClick={() => open()}>
      <div className={classes.surveyItemLeft}>
        <div className={classes.surveyItemLeftTop}>
          <div className={classes.surveyItemDays}>{survey.days_left}</div>
          <div className={classes.surveyItemTime}>{survey.duration}</div>
        </div>
        <div className={classes.surveyItemLeftBottom}>
          <div className={classes.surveyItemTitle}>{survey.display_name || survey.name || survey.survey}</div>
          <div>
            <span className={classes.surveyItemCost}>{survey.reward_text}</span>
          </div>
        </div>
      </div>
      <div className={classes.surveyItemRight}>
        <ChevronRightIcon />
      </div>
    </div>
  );
};

export default Pollfish;
